import { string as yupString } from 'yup';

export const checkIsValidEmail = (email: string) => {
    return yupString().email().isValidSync(email);
};
